/**
 * Sorts an array of objects alphabetically by their `name` property (case-insensitive).
 * Safe to use on any array — returns original if not a valid array.
 */
export function sortByName(arr) {
  if (!Array.isArray(arr)) return arr;
  return [...arr].sort((a, b) => {
    const nameA = (a?.name ?? "").toString().toLowerCase();
    const nameB = (b?.name ?? "").toString().toLowerCase();
    return nameA.localeCompare(nameB);
  });
}
